import { Button } from "@mui/material";

import { useLogout } from "../../hooks/useLogout";

export const LogoutButton: React.FC<React.PropsWithChildren> = ({ children }) => {
    const logout = useLogout();
    return (
        <Button onClick={logout} variant="outlined">
            {children ?? "Logout"}
        </Button>
    );
};
